import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './DateAndTime.css';
import Footer from '../../components/UI/Footer/Footer';
import DatePicker from '../../components/DatePicker/DatePicker';
import TimePicker from '../../components/TimePicker/TimePicker';
import { bookingProcessSetStep } from '../../store/actions/bookingProcess';
import { BOOKING_STEPS } from '../../constants';
import globalClasses from '../../App.css';
import { changeStoreModalOpen, changeStoreModalSetStore } from '../../store/actions/changeStoreModal';
import { LogoLoader } from '../../components/UI/Loader/LogoLoader';
import RestaurantCard from '../../components/UI/RestaurantCard/RestaurantCard';

class DateAndTime extends Component {

  continueHandler = () => {
    this.props.onNextStep();
    this.props.history.push({
      pathname: '/menu',
    });
  }

  backHandler = () => {
    this.props.onBackStep();
    this.props.history.goBack();
  }

  componentDidMount() {
    this.props.changeStoreModalOpen(false);
    this.props.bookingProcessSetStep();
  }

  render() {
    const store = this.props.store.stores[this.props.store.storeIdSelected];
    let maxBookingDaysInAdvance = store ? store.maxBookingDaysInAdvance || 30 : 30;

    let disableButton = true;

    if (this.props.time !== null) {
      disableButton = false;
    }

    return (
      <div style={{ marginBottom: '100px' }}>
        {this.props.isChangeStoreModalOpen ?
          <React.Fragment>
            <p className={globalClasses.PageTitle}>{this.props.translations.label_edit_location}</p>
            {this.props.isModalChangeStoreLoading ?
              <LogoLoader />
              :
              <React.Fragment>
                {this.props.stores.length === 0 ?
                  <p className={globalClasses.SubTitle}>{this.props.translations.label_no_store_available}</p>
                  :
                  <React.Fragment>
                    <div className={classes.StoreListContainer}>
                      {this.props.stores.map(store => (
                        <RestaurantCard
                          key={store.id}
                          id={store.id}
                          name={store.name}
                          imgSrc={store.logo ? store.logo.url : ''}
                          clicked={() => this.props.changeStore(store.id)} />
                      ))}
                    </div>
                  </React.Fragment>
                }
              </React.Fragment>}
              <Footer
                continueLbl={this.props.translations.label_continue}
                continueDisabled={disableButton}
                backClick={() => this.props.changeStoreModalOpen(false)}
                nextClick={null} 
            />
          </React.Fragment>
          :

          <React.Fragment>
            <p className={globalClasses.PageTitle}>{this.props.translations.label_choose_time}</p>
            <div className={classes.MainContainer}>
              <DatePicker
                maxBookingDaysInAdvance={maxBookingDaysInAdvance}
              />
              <TimePicker />
            </div>
            <Footer
              continueLbl={this.props.translations.label_continue}
              continueDisabled={disableButton}
              backClick={this.backHandler}
              nextClick={this.continueHandler} 
            />
          </React.Fragment>
        }

      </div>
    )
  }
};

const mapStateToProps = state => {
  return {
    time: state.bookingProcessReducer.timeSelected,
    store: state.storeReducer,
    bookingProcess: state.bookingProcessReducer,
    translations: state.settingsReducer.translations,
    isChangeStoreModalOpen: state.changeStoreModalReducer.isOpen,
    isModalChangeStoreLoading: state.changeStoreModalReducer.isLoadingNewStore || state.changeStoreModalReducer.isLoadingStores,
    stores: state.changeStoreModalReducer.availableStores,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onNextStep: () => { },
    onBackStep: () => { },
    bookingProcessSetStep: () => dispatch(bookingProcessSetStep(BOOKING_STEPS.DATE_TIME)),
    changeStoreModalOpen: isOpen => dispatch(changeStoreModalOpen({ isOpen })),
    changeStore: storeId => dispatch(changeStoreModalSetStore(storeId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DateAndTime);


// WEBPACK FOOTER //
// ./src/containers/DateTime/DateAndTime.js